import {DatabaseViewType} from '../../../models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
import {IconNameType} from '../../../enum/IconNameType'
import {DatabaseViewTypeToDefaultIconNameTypeMap} from '../maps/DatabaseViewTypeToDefaultIconNameTypeMap'

/**
 * The icon a database view shows as a resource (sidebar, resource items): its own icon, otherwise the
 * default icon of its type.
 */
export function getDatabaseViewResourceIconNameType(databaseView: {
  type: DatabaseViewType
  iconNameType?: IconNameType | null
}): IconNameType {
  return databaseView.iconNameType
    || DatabaseViewTypeToDefaultIconNameTypeMap.get(databaseView.type)
    || IconNameType.Table
}
